import React from "react";
import { useStore } from "react-redux";

import Price from "../type/price";
import { CloseIcon, InfoIcon } from "../utils/components/icons";

const PreisInfo = (props) => {
  const configStorage = useStore().getState().configStorage;
  const basketStorage = useStore().getState().basketStorage;
  const { item } = props || {};
  if (!item || !configStorage.isMaShop()) return null;

  const provision = basketStorage.getImItemEnthalteneProvision(item);
  const gebuehr = (props.gebuehr && ""!== props.gebuehr) ? Price.create(props.gebuehr.replace('.', '').replace(',', '.')) : Price.create(props.gebuehr);
  let gesamtsumme, footnote = null;
  if (configStorage.isAnkaufShop()) {
    gesamtsumme = Price.create(provision.getPrice() - gebuehr.getPrice());
    footnote = <p className="small mt-one">
      *) <u>Bitte beachten:</u> Bei Ankäufen führt eine negative Konditionsänderung zu einer Erhöhung des Gesamtertrags
      zu Lasten des Kunden.
    </p>
  } else {
    gesamtsumme = Price.create(provision.getPrice() + gebuehr.getPrice());
  }

  return (
    <>
      <div className="modal fade" id={"preismodal" + item.kennziffer} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="false">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn btn-default ser-close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <CloseIcon></CloseIcon>
              </button>
              <h3 className="modal-title fw-bold text-gray" id="modalLabel">
                Preisinformationen
              </h3>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-8">Im Kurs enthaltene Provision</div>
                <div className="col-4 text-end">  {provision.toEuro()}</div>
              </div>
              <div className="row">
                <div className="col-8">Konditions&shy;änderung Institut
                  {footnote ? "*" : null}
                </div>
                <div className="col-4 text-end">  {gebuehr.toEuro()} </div>
              </div>
              {footnote}
              <div className="row">
                <div className="col-8">Gesamtertrag Institut</div>
                <div className="col-4 text-end">  {gesamtsumme.toEuro()}</div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                data-bs-toggle="modal"
                data-bs-target={"#preismodal" + item.kennziffer}
                data-bs-dismiss="modal"
                className="btn btn-default pull-left"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
      <button type="button"
        data-bs-toggle="modal"
        data-bs-target={"#preismodal" + item.kennziffer}
        data-bs-backdrop="static"
        className="btn text-primary pull-right"
        aria-label="Preisinfos anzeigen"
      >
        <InfoIcon />
      </button>
    </>
  );
}

export default PreisInfo;
